import translating from './translate.json';

const validateForm = (field, translateField) => {
  switch (field) {
    case 'password':
      return {
        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        message: translating.passwordFormatErrMsg
      };
    case 'tz':
      /^(0|[0-9][0-9]*)$/;
      break;
    case 'mobile':
      return {
        value: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
        message: `${translating.format} ${translateField} ${translating.erroneous}`
      };
    case 'phone':
      return {
        value: /^[0-9]{9,10}$/,
        message: `${translating.format} ${translateField} ${translating.erroneous}`
      };
    case 'email':
      return {
        value:
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: `${translating.format} ${translateField} ${translating.erroneous}`
      };
    case 'ssn':
      return {
        value: /^(0|[0-9][0-9]*)$/,
        message: `${translating.format} ${translateField} ${translating.erroneous}`
      };
    default:
      return {
        value: /^[a-z\u0590-\u05fe\s]+$/i,
        message: `${translating.format} ${translateField} ${translating.erroneous}`
      };
  }
};

const isValidIsraeliID = (x) => {
  x = String(x).padStart(9, '0');
  var id = String(x).trim();
  return (
    id.length === 9 &&
    !isNaN(id) &&
    Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }) %
      10 ===
      0
  );
};

const invalidDate = (input) => {
  if (Object.prototype.toString.call(input) === '[object Date]') {
    if (isNaN(input)) {
      return true;
    }
  }
  return false;
};
const phoneFormat = (telMumber, type) => {
  if (telMumber) {
    if (type === 'phone')
      if (telMumber.length === 9)
        return telMumber.slice(0, 2) + '-' + telMumber.slice(2, 9);
      else return telMumber.slice(0, 4) + '-' + telMumber.slice(4, 10);
    return (
      telMumber.slice(0, 3) +
      '-' +
      telMumber.slice(3, 6) +
      '-' +
      telMumber.slice(6, 10)
    );
  }
};

const calcBMI = (height, weight) => {
  return ((weight / height / height) * 10000).toFixed(2);
};

const getAge = (dateString) => {
  dateString = dateString.split('.');
  dateString = `${dateString[1]}.${dateString[0]}.${dateString[2]}`;
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
export {
  validateForm,
  isValidIsraeliID,
  phoneFormat,
  calcBMI,
  getAge,
  invalidDate
};
